import {createContext} from "react";
import {SegmentCategory} from "../../apis/requests/segments/types";
import type {CategoryHeaderInfo} from "./CategoryHeader";

type SegmentTypeSeparatorState = {
  firstGeneralId: number | undefined;
  isBlocked: boolean;
};

export const SegmentTypeSeparatorContext = createContext<SegmentTypeSeparatorState>({
  firstGeneralId: undefined,
  isBlocked: false,
});

export type CategoryDragState = {
  draggedId: number | undefined;
  draggedCategory: SegmentCategory | undefined;
};

export const IDLE_CATEGORY_DRAG: CategoryDragState = {draggedId: undefined, draggedCategory: undefined};

export const CategoryDragContext = createContext<CategoryDragState>(IDLE_CATEGORY_DRAG);

export const CategoryHeaderContext = createContext<Map<number, CategoryHeaderInfo>>(new Map());
